module.exports = __webpack_public_path__ + "static/media/placeholder.d2752a30.png";